module.exports = __webpack_public_path__ + "img/1_008.903b2f5e.jpg";